module.exports = __webpack_public_path__ + "static/media/logo_ammc.9462f5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ammc.png
// module id = 233
// module chunks = 0